
import { defineComponent } from 'vue'

import IssueDetailMixin from '~/mixins/issueDetailMixin'
import RepoDetailMixin from '~/mixins/repoDetailMixin'

export default defineComponent({
  name: 'IgnoreIssueTestFiles',
  mixins: [IssueDetailMixin, RepoDetailMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    checkId: {
      type: String,
      default: ''
    },
    shortcode: {
      type: String
    },
    repositoryId: {
      type: String,
      default: ''
    },
    prLabel: {
      type: String,
      default: 'pull request'
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  async fetch(): Promise<void> {
    await this.fetchRepoDetails(this.baseRouteParams)
  },
  computed: {
    hasPatterns(): boolean {
      const testPatterns = this.repository.config?.test_patterns ?? []
      return testPatterns.length > 0
    },
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {} as {
        repositoryId?: string
        checkId?: string
        issueShortcode?: string
        alsoCreateRule?: boolean
      }

      if (this.checkId) {
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
        params.alsoCreateRule = true
      } else {
        params.repositoryId = this.repositoryId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueTestPattern(params)
        this.$toast.success(`${this.issueShortcode} ignored for all test files.`)

        this.$emit('ignore', response.checkIssueIds)
      } catch (e) {
        this.$logErrorAndToast(
          e as Error,
          'Something went wrong while ignoring this issue, please contact support.',
          undefined,
          {
            context: 'Ignore Issue',
            params: {
              method: 'Ignore Issue Test Files',
              ...params
            }
          }
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
